export default "/images/7e1a59e502c6b4a7f2c686ce52aebe9c.avif";